import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

import { KnittingMachine, KnittingMachineSearchRequest } from '../../models/knitting/knitting';
import { ApiResponse } from '@card-software/nexus-utilities';

@Injectable({
  providedIn: 'root',
})
export class KnittingMachineProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.productionApi + '/api/v1/knitting-machine';

  public searchMachineDetail(body: KnittingMachineSearchRequest): Observable<ApiResponse<KnittingMachine[]>> {
    return this.httpClient.post<ApiResponse<KnittingMachine[]>>(`${this.baseUrl}/search`, body);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public getfabricCode(): Observable<ApiResponse<any[]>> {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return this.httpClient.get<ApiResponse<any[]>>(`https://item.api.dev.sierra-erp.com/api/v1/fabric-categories/all`);
  }

  public updateKnittingMachine(knittingMachine: KnittingMachine): Observable<KnittingMachine> {
    return this.httpClient.put<KnittingMachine>(`${this.baseUrl}/${knittingMachine.id!}`, knittingMachine);
  }

  public shiftMachines(): Observable<KnittingMachine[]> {
    return this.httpClient.post<KnittingMachine[]>(`${this.baseUrl}/shift-change`, null);
  }
}
